import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Ho mia patrino – Tero!
    </p>
    
    <p class="mb-3">
      Mi vidas, kiel vi maljuniĝas kaj velkas apud mi. 
      Kion mi faru por ke vi resaniĝu?
    </p>

    <p class="mb-3">
      Vi poiomete perdas viajn harojn – arbarojn; viajn dentojn – montojn, kiujn homoj traboras per tuneloj aŭ simple fofosas, se ili ŝajnas obstakloj. 
      Homoj malpurigas kaj malklargas viajn okulojn – lagojn kaj marojn, kiuj iĝas venenigitaj kaj mortaj. 
      Oni elprenas viajn internajn organojn kiel ercon, vian sangon oni elsuĉas kiel nafton, vian haŭton oni kovras per asfalto por ke vi sufokiĝu sub ĝi. 
    </p>
    
    <p class="mb-3">
      Ĉu vere vi tiel senpovas kontraŭ tiu perforto? 
      Ĉu oni jam plene senfortigis vin, kaj vi baldaŭ silente mortos? Ne, mi scias, ke vi nur retenis vian energion, ne dezirante dispremi muson per la pezo de potenca montego; por tio sufiĉus ja simpla piedbato. 
      Kaj mi vidas jam antaŭsignojn de via reviviĝo, ho Tero, de via indigno kontraŭ tiu malgranda, sed malica mikrobo, kiu ronĝas vian korpon kaj subfosas la sanon. 
      Por vi sufiĉos nur blovi, por ke li tute malaperu de sur via korpo. 
    </p>
    
    <p class="mb-3">
      Ĉu vi faros tion? 
      Ĉu li mem rekonsciiĝos kaj ne plu turmentos sian naskintinon?
    </p>

    <p class="mb-3">
      La tempo montros. 
    </p>
    
    <p class="mb-3">
      Sed en unu de la variantoj ni simple ne ekscios tion. 
    </p>
    `
  )
}

const itemName = {
  esp: 'Alvoko de Tera ido'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;